'use client'

import { FeaturesStrip, Hero, HowItWorks, MobileShowcase, UseCaseCTA } from '@/components/home'
import { useAuth } from '@/contexts/AuthContext'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export default function Home() {
  const { currentUser, isLoading } = useAuth()
  const router = useRouter()

  useEffect(() => {
    // If logged in, go to dashboard
    if (!isLoading && currentUser) {
      router.push('/dashboard')
    }
  }, [currentUser, isLoading, router])

  // Show loading only during initial auth check
  if (isLoading) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <div className='animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900' />
      </div>
    )
  }

  // Don't render if user is logged in (will redirect)
  if (currentUser) {
    return null
  }

  return (
    <>
      <Hero />
      <FeaturesStrip />
      <MobileShowcase />
      <HowItWorks />
      <UseCaseCTA />
    </>
  )
}
